export const API_ENDPOINTS = {
  WEEKENDPOLICY: {
    GET_WEEKENDPOLICY: () => `/attendance-weekend-policy`,

    ADD_WEEKENDPOLICY: () => `/attendance-weekend-policy`,

    UPDATE_WEEKENDPOLICY: (yearMonth) =>
      `/attendance-weekend-policy?month=${yearMonth}`,
  },

  ATTENDANCE_MUSTER: {
    GET_SAMPLE_EXCEL: () => `/attendance-muster/sample`,

    GET_DOWNLOAD_MUSTER_EXCEL: (yearMonth) =>
      `/attendance-muster/export?monthYear=${yearMonth}`,

    MUSTER_IMPORT: () => `/attendance-muster/import`,
    GET_ATTENDANCE_MUSTER: (
      empId,
      reviewer,
      repManager,
      payrollStatus,
      yearMonth,
      sortDirection,
      page,
      size,
      search
    ) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (reviewer) queryParams.append("reviewer", reviewer);
      if (repManager) queryParams.append("repManager", repManager);
      if (payrollStatus) queryParams.append("payrollStatus", payrollStatus);
      if (yearMonth) queryParams.append("monthYear", yearMonth);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);

      return `/attendance-muster?${queryParams.toString()}`;
    },

    ADD_LOP: () => `/attendance-muster/add-lop`,
    PROCESS_ATTENDANCE: (params) =>
      `/attendance-muster?monthYear=${params.monthYear}&isAll=${params.isAll}${
        params.empId ? `&empId=${params.empId}` : ""
      }`,
    GET_OVERRIDE: (empId, month) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("monthYear", month);

      return `attendance-muster/override?${queryParams.toString()}`;
    },

    UPDATE_OVERRIDE: () => `/attendance-muster/emp-override`,

    GET_OVERRIDE_HISTORY: (empId, month) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("monthYear", month);

      return `attendance-muster/override-history?${queryParams.toString()}`;
    },

    DELETE_OVERRIDE: () => `/attendance-muster`,

    GET_LOP: (empId, month) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("monthYear", month);

      return `attendance-muster/add-lop-count?${queryParams.toString()}`;
    },
  },
  ONSITEATTENDANCE: {
    BULK_UPLOAD: () => `employee-attendance/bulk-upload`,
    PROCESS_BY_DATE: (date) =>
      `employee-attendance/process-by-date?date=${date}`,
    // EMPLOYEE_ATTENDANCE_REPORT: (empId, fromDate, toDate) =>
    //   `employee-attendance/report?empId=${empId}&fromDate=${fromDate}&toDate=${toDate}`,

    EMPLOYEE_ATTENDANCE_REPORT: (empId, fromDate, toDate) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);

      return `employee-attendance/report?${queryParams.toString()}`;
    },

    EMPLOYEE_ATTENDANCE_PUNCH: (fromDate, toDate) => {
      const queryParams = new URLSearchParams();

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);

      return `employee-attendance/reports?${queryParams.toString()}`;
    },

    GET_ON_SITE_ATTENDANCE_SAMPLE: () =>
      `/employee-attendance/onsite-attendance-sample-download`,
  },

  SHIFT_ROSTER_IMPORT: {
    GET_DATE_TYPE_SAMPLE: () => `/attendance-day-type-history/sample`,

    DATE_TYPE_IMPORT: () => `/attendance-day-type-history/import`,

    GET_SHIFT_ROSTER_SAMPLE: () => `/shift-roster/sample`,

    SHIFT_ROSTER_IMPORT: () => `/shift-roster/import`,
  },

  // /shift-roster
  SHIFT_ROSTER: {
    // GET_SHIFT_ROSTER: () => `/shift-roster`,
    // ?monthYear=04-2025&empId=TEMP3
    GET_SHIFT_ROSTER: (month, empId, sortDirection, page, size, search) => {
      const queryParams = new URLSearchParams();
      if (month) queryParams.append("monthYear", month);
      if (empId) queryParams.append("empId", empId);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);
      return `/shift-roster?${queryParams.toString()}`;
    },
    GET_DAY_TYPE: (empId, month) => {
      const queryParams = new URLSearchParams();
      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("monthYear", month);
      return `/attendance-day-type-history?${queryParams.toString()}`;
    },
  },

  MONTHENDPROCESS: {
    GET_LEAVE_APPLICATION: (
      leaveType,
      empId,
      month,
      sortDirection,
      page,
      size,
      search
    ) => {
      const queryParams = new URLSearchParams();

      if (leaveType) queryParams.append("leaveType", leaveType);
      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("month", month);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);
      return `attendance-regularization/get-admin-leave-apply?${queryParams.toString()}`;
    },

    GET_ATTENDANCE_REGULARIZATION: (
      month,
      empId,
      sortDirection,
      page,
      size,
      search
    ) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId);
      if (month) queryParams.append("month", month);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);
      return `attendance-regularization/get-admin-regularization?${queryParams.toString()}`;
    },
    ADD_ATTENDANCE_REGULARIZATION: () =>
      `attendance-regularization/admin-approve-regularization`,
    ADD_ATTENDANCE_LEAVE_APPROVAL: () =>
      `leave-approval/admin/approve-or-reject`,
  },
  ADMIN_ATTENDANCE_REPORT: {
    GET_ADMIN_ATTENDANCE_REPORT: (month, sortDirection, page, size, search) => {
      const queryParams = new URLSearchParams();
      if (month) queryParams.append("month", month);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);
      return `/employee-attendance/admin-attendance-report?${queryParams.toString()}`;
    },

    GET_ADMIN_ATTENDANCE_TRACKER: (
      startDate,
      endDate,
      empId,
      workLocation,
      deparment,
      swipeMethod
    ) => {
      const queryParams = new URLSearchParams();
      // if (month) queryParams.append("month", month);
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (empId) queryParams.append("empId", empId);
      if (workLocation) queryParams.append("workLocation", workLocation);
      if (deparment) queryParams.append("deparment", deparment);
      if (swipeMethod) queryParams.append("swipeMethod", swipeMethod);
      return `/employee-attendance/admin-attendance-tracker?${queryParams.toString()}`;
    },
    GET_DOWNLOAD_REPORT_EXCEL: (yearMonth) =>
      `/employee-attendance/export-admin-attendance-report?month=${yearMonth}`,

    GET_DOWNLOAD_TRACKER_EXCEL: (
      startDate,
      endDate,
      empId,
      workLocation,
      deparment,
      swipeMethod
    ) => {
      const queryParams = new URLSearchParams();
      // if (month) queryParams.append("month", month);
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (empId) queryParams.append("empId", empId);
      if (workLocation) queryParams.append("workLocation", workLocation);
      if (deparment) queryParams.append("deparment", deparment);
      if (swipeMethod) queryParams.append("swipeMethod", swipeMethod);
      return `/employee-attendance/admin-attendance-tracker-export?${queryParams.toString()}`;
    },
  },
};
